
import { useState, useCallback } from 'react';
import { BlogPost } from '@/types/blog';

interface UsePostsStateReturn {
  posts: BlogPost[];
  setPosts: (posts: BlogPost[]) => void;
  hasMore: boolean;
  setHasMore: (hasMore: boolean) => void;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  totalPosts: number;
  setTotalPosts: (total: number) => void;
  addPosts: (newPosts: BlogPost[]) => void;
  resetPosts: () => void;
}

export const usePostsState = (initialPage: number = 1): UsePostsStateReturn => {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [totalPosts, setTotalPosts] = useState(0);

  // Helper to add posts, filtering out duplicates
  const addPosts = useCallback((newPosts: BlogPost[]) => {
    if (newPosts.length > 0) {
      setPosts(currentPosts => {
        const existingIds = new Set(currentPosts.map(post => post.id));
        const uniqueNewPosts = newPosts.filter(post => !existingIds.has(post.id));
        
        console.log(`Adding ${uniqueNewPosts.length} new unique posts (filtered ${newPosts.length - uniqueNewPosts.length} duplicates)`);
        
        return [...currentPosts, ...uniqueNewPosts];
      });
      
      setTotalPosts(prev => prev + newPosts.length);
    }
  }, []);

  // Reset posts state
  const resetPosts = useCallback(() => {
    setPosts([]);
    setTotalPosts(0);
  }, []);

  return {
    posts,
    setPosts,
    hasMore,
    setHasMore,
    currentPage,
    setCurrentPage,
    totalPosts,
    setTotalPosts,
    addPosts,
    resetPosts
  };
};
